
































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HelloWorld extends Vue {
  // Data property

  // Component method
  // updateMyProperty ($event) {
  //   this.myDataProperty = $event.target.value
  // }
  // testProperty!: string;
  // chosenMenu!: string;

  @Prop() private msg!: string;

  testProperty = "haha";
  chosenMenu = "";
  showForm = false;
  showMettaoText = true;
  showPhoneNumber = "this phone number";
  stories = {};
  onClick(menuItem: string): void {
    this.showMettaoText = false;
    this.chosenMenu = menuItem;
  }
  showMettao(): void {
    this.showMettaoText = !this.showMettaoText;
    this.chosenMenu = "";
  }
  mounted() {
    this.stories = {
      Mission: ``,
      Mission2: `With Mettao, we want to have a positive influence in this world. We manifestated because of abundance, an urge for creativity and the desire to help other people. 

So, what is a positive influence? We believe that it can arrive from a uncomplicated question, and often the question behind a question, behind a...

So, what do we actually offer? We want to help explore the challenges you have, together. See if that is the real question. Afterwards we can look if automation can be part of the solution. If that is the case, we would love to build that for you.
`,
      About: `We are a Utrecht based company, consisting of a small team interested in solving problems. Though we love designing and building solutions, we firmly believe that IT isnt's always the best answer. 

Our core team consists of a UX designer, a developer and a system architect. We have preferred partners when working on larger or specific projects.

Some keywords involve: PHP, Laravel, Javascript, Puppeteer, VueJS, Tailwind, Frontend, Backend, Excel, PowerBI, Illustrator and D3`,
      Contact: ``,
      Projects: `These are some projects we have completed or participated in. Some of these projects are done while working for Dialogic. Not all our projects are publicly available. Feel free to ask for more information.

VNG: designed and developed a web application to analyze 700.000 terms and definitions. Used by Dutch municipalities and governemnts: Request a demo.

VNG: designed and developed a website to present the outcome of the above web application. Target audience is municipalities and here is the <a class="link" href="https://begrippenomgevingswet.nl/">link</a>

Distri Data: developed a testing tool that records user actions and can playback these actions.

Distri Data: Currently developing a large webstore where food-industry related companies can place orders.

Google: Handle surveys for Google's Digitale Werkplaats

D3 (CBB): Developed a website and components to show a dashboard to health professionals: <a href="http://www.datadialoogdoen.nl" class="link">http://www.datadialoogdoen.nl/</a> - most content is behind a login screen

Provincie Brabant: research and presentation of festivals in the Netherlands, it shows which festivals are like each other, based on the amount of same artists that are on both festivals. <a href="https://dialogiconderzoek.nl/festivals/b5.html" class="link">link</a>

KvK (Kamer van Koophandel, chamber of commerce): developed a dashboard to analyze and visualise user feedback.
`,
    };
  }
}
